import { useState } from 'react';
import './App.css';

const shuffleArray = arr => arr
  .map(a => [Math.random(), a])
  .sort((a, b) => a[0] - b[0])
  .map(a => a[1]);

function App() {
  const [words, setWords] = useState(
    [
      {
        word: "Superkraft",
        check: false
      },
      {
        word: "Vertrauen",
        check: false
      },
      {
        word: "Produkt",
        check: false
      },
      {
        word: "Fokus",
        check: false
      },
      {
        word: "Home-Office",
        check: false
      },
      {
        word: "Entscheidung",
        check: false
      },
      {
        word: "API",
        check: false
      },
      {
        word: "Chat",
        check: false
      },
      {
        word: "Webcam",
        check: false
      },
      
    ]
  );
    
    const isWinner = (words[0].check && words[1].check && words[2].check) || 
                     (words[3].check && words[4].check && words[5].check) || 
                     (words[6].check && words[7].check && words[8].check) || 
                     (words[0].check && words[3].check && words[6].check) || 
                     (words[1].check && words[4].check && words[7].check) || 
                     (words[2].check && words[5].check && words[8].check) || 
                     (words[0].check && words[4].check && words[8].check) || 
                     (words[2].check && words[4].check && words[6].check);

  return (
    <>
    <div className="App App-header">
        {words.map((e,i) => {
          const shouldBreak = ((i+1) % 3 === 0);
          return <><div 
          key={e.word}
          onClick={_ => {

            setWords(words.map((w, j) => {
              if(j === i) {
                return {...w, check: !w.check}
              } else {
                return w
              }
            }))
          }}
          
          className={`word ${(e.check ? 'check' : '')}`}>{e.word}</div>{shouldBreak && <br/>}</>
        })}
       
        
    <div className="flex">
      <div> 
        {isWinner && <h3>Winner 🥳🥳🥳</h3>}{!isWinner && <h3>Nope 👎</h3>}
      </div>
      <div>
        <h3 onClick={ _ => {setWords(shuffleArray(words))}}>🎲 Shuffle 🎲</h3>
      </div>
      <div
          onClick={_ => {
            const i = prompt("Insert nine words separated by commas");
            if(i === null || i === '') {
              return;
            }
            const w = i.split(',').concat((new Array(9)).fill("🤷")).splice(0,9)
            setWords(
              w.map(word => {return {word, check:false}})
            )
          }}>
            <h3>Import ↗️</h3>
      </div>
    </div>
    </div>
    </>

  );
}

export default App;
